<mat-toolbar md-scroll-shrink>
  <button mat-icon-button *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()">
    <mat-icon *ngIf="!sidenav.opened"> menu </mat-icon>
    <mat-icon *ngIf="sidenav.opened"> close </mat-icon>
  </button>
  <div class="tile-icon">
    <img class="" src="../../assets/icons/menu_logo.png" alt="HondaLink" />
  </div>

  <span class="spacer"></span>
  <div class="top-nav-bar" *ngIf="sidenav.mode === 'side'">
    <app-top-nav></app-top-nav>
  </div>
</mat-toolbar>

<div class="divider"></div>

<div *ngIf="sidenav.mode === 'over' && sidenav.opened">
  <app-top-nav></app-top-nav>
  <div class="divider"></div>
</div>
<div class="main-container">
  <mat-sidenav-container class="mat-container">
    <mat-sidenav #sidenav="matSidenav">
      <p class="name font-18 black-color">Welcome {{ acctDetail ? acctDetail?.firstName : userName }}</p>
      <p class="designation">{{ acctDetail ? acctDetail?.email : userEmail}}</p>
      <app-side-nav [accountExist]="accountExist" [gdoPortalActive]="isGdoPortalActive"></app-side-nav>
      <app-faqs></app-faqs>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-footer-component></app-footer-component>
</div>